import { useEffect, useState } from "react";

// src/components/Loading.jsx
const Loading = () => {
	const [visible, setVisible] = useState(true);

	useEffect(() => {
		const timer = setInterval(() => {
			setVisible((prev) => !prev); // toggle visibility
		}, 500);

		return () => clearInterval(timer); // cleanup on unmount
	}, []);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				minHeight: "100vh",
				backgroundColor: "#f9f9f9",
				color: "#333",
				textAlign: "center",
			}}
		>
			<img
				src="/logo.png"
				alt="Logo"
				style={{
					width: "150px",
					marginBottom: "30px",
					opacity: visible ? 1 : 0,
					transition: "opacity 0.5s linear",
				}}
			/>
			<p style={{ fontSize: "18px" }}>Loading, please wait...</p>
		</div>
	);
};

export default Loading;
